/**
 * Styles.
 */
import './style.scss';

/**
 * External Dependencies
 */
import React from 'react';
import { useSelector } from 'react-redux';

/**
 * Internal Dependencies
 */
import AsyncComponent from '../../components/async-component';
import PageWrap from '../../components/page-wrap';
import PageTitle from '../../components/page-title';
import PageContent from '../../components/page-content';
import { Row, Col } from 'reactstrap';
import NavigationTopRight from '../../components/navigation-top-right';
import { parseJSON } from '../../utils';
import Icon from '../../components/icon';

const MyQris = () => {
  const currentUser = useSelector(state => state.currentUser);
  const channelConfig = parseJSON(currentUser?.payChannelConfig?.config, []);
  const { isSelfDomain, paymeLink } = currentUser || {};
  const isDisplayQris =
    currentUser?.account?.xenditStaticQris &&
    currentUser?.payChannelConfig?.isQRISStaticApproved &&
    channelConfig?.find(i => i.type === 'qris_static')?.status;
  const qrisURL = isSelfDomain ? `https://${paymeLink}/qris` : `https://mayar.to/${paymeLink}/qris`;

  return (
    <PageWrap>
      <PageTitle
        className="d-none d-sm-block"
        breadcrumbs={{
          '/': currentUser ? currentUser.name : ' '
        }}
      >
        <Row className="mb-0">
          <Col md="4" className="d-flex flex-column">
            <h1>Qris Statis</h1>
            {isDisplayQris && (
              <a href={qrisURL} target="_blank" rel="noopener noreferrer" className="mt-10 text-primary h5">
                {qrisURL.replace('https://', '')} <Icon name="external-link" />
              </a>
            )}
          </Col>
          <Col md="8" className="text-right">
            <NavigationTopRight />
          </Col>
        </Row>
      </PageTitle>
      <PageContent>
        <AsyncComponent component={() => import('./content')} />
      </PageContent>
    </PageWrap>
  );
};

export default MyQris;
